module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('scroller', [_c('div', {
    staticClass: " weex-ct weex-div",
    style: ({
      width: _vm._px2rem(_vm.width + 'px', 75),
      height: _vm._px2rem(_vm.height + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.gradientTopStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  })])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ee62acaa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee62acaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-gradient/index.vue
// module id = 666
// module chunks = 0 1